import { useQuery } from "react-query";

import useQSBuilder from "../../hooks/useQSBuilder";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { viewingQueryKeys } from "./queryKeys";
import { IViewing } from "../../models/viewing/Viewing";

export function useViewingsByPerson(agencyId: string, personId: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const viewings = useQuery({
    queryKey: viewingQueryKeys.byPerson(agencyId, personId),
    queryFn: () =>
      get(
        `/viewing/${agencyId}${buildQs({ personId })}`
      ) as unknown as IDefaultResponseWithData<IViewing[]>,
    refetchOnWindowFocus: false,
  });

  return {
    viewings,
  };
}
